<template>
	<div>
		<k-btn icon size="m" no-margin @click="expand = !expand" >
			<k-icon size="m">{{expand ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</k-icon>Stream info
		</k-btn>
		<k-btn icon no-margin icon-name="refresh" size="s" @click="analyze"></k-btn>
		<div v-if="expand">
			<template v-if="info.format">
				<div class="ks-title mt-1">General:</div>
				<k-key-value :items="get_general_info"></k-key-value>
			</template>
			<div v-for="stream in info.streams">
				<div class="ks-title mt-1" style="text-transform: capitalize;">{{stream.codec_type}} stream ({{stream.id}}):</div>
				<k-key-value :items="stream"></k-key-value>
			</div>
		</div>
	</div>
</template>

<script>
import datelib from '@/lib/date.js'

export default {
	props: ["channel", "alternative"],
	data () {
		var ch = this.$socket.channel("channels:analyze:"+this.channel+":"+this.alternative);
		return {
			ws_channel: ch,
			info: {},
			expand: false
		}
	},
	watch: {

	},
	mounted () {
		var self = this;
		this.ws_channel.on("analyze", function(data) {
			self.info = data.data;
		});
		this.ws_channel.join();

	},
	computed: {
		get_general_info() {
			var date = "";
			if (typeof(this.info.timestamp) != "undefined") {
				date = datelib.format_date(this.info.timestamp) + " " + datelib.format_time(this.info.timestamp);
			}

			return {
				"Format": _.get(this.info, ["format","format_long_name"],""),
				"Last updated": date
			}
		}
	},
	methods: {
		analyze() {
			this.ws_channel.push("analyze", {"channel_uuid": this.channel, "alternative": this.alternative});
		}
	}
}
</script>